import { render, staticRenderFns } from "./ShoppingCardFirst.vue?vue&type=template&id=52637074&scoped=true&"
import script from "./ShoppingCardFirst.vue?vue&type=script&lang=js&"
export * from "./ShoppingCardFirst.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCardFirst.vue?vue&type=style&index=0&id=52637074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52637074",
  null
  
)

export default component.exports